import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { OtpComponent } from './otp/otp.component';
import {MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MatListModule,MatExpansionModule,MatCardModule,MatFormFieldModule,MatInputModule,MatButtonModule,MatRadioModule,MatStepperModule,MatMenuModule, MatCheckboxModule} from '@angular/material';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service'
import { NgOtpInputModule } from 'ng-otp-input';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MobileComponent } from 'src/app/pages/checkout-process/mobile/mobile.component';
import {MatRippleModule} from '@angular/material/core';
import { FooterModule } from '../footer/main/footer.module';
import { ReuseModule } from 'src/app/reuse/reuse.module';
import { TrackMobileOrderModule } from '../../pages/checkout-process/order-success/order-success-mobile/track-mobile-order/track-mobile-order.module';
import { WebOtpDirective } from 'src/app/web-otp.directive';

@NgModule({ 
  declarations: [
    LoginComponent,
    OtpComponent,
    MobileComponent,
    WebOtpDirective
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    FormsModule,
    MatStepperModule,
    MatMenuModule,
    NgOtpInputModule,
    LazyLoadImageModule,
    MatRippleModule,
    ReuseModule,
   
    // FooterModule
  ],
  exports: [
    LoginComponent,
    OtpComponent,
    MobileComponent,

  ],
  providers: [
    OtpComponent,
    LoginComponent,
    CookieService,
   
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }
  ]
})

export class MobileModule { }
